'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var EmailIcon = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 40 40" }, props),
    React__default['default'].createElement("path", { fill: "#323232", d: "M10.5 14v13h19V14h-19zm16.954 1L20 20.986 12.545 15h14.909zM28.5 26h-17V15.446l8.5 6.82 8.5-6.82V26z" }))); };

exports.default = EmailIcon;
//# sourceMappingURL=index.js.map
